function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import c from 'classnames';
import urlParse from 'url';
import { isValidImage, useImageLoader, calculateTargetSrc } from '../helpers';
import './style.scss';

// extend html img props

var AdaptivePicture = function AdaptivePicture(_ref) {
  var src = _ref.src,
    _onLoad = _ref.onLoad,
    alt = _ref.alt,
    objectFit = _ref.objectFit,
    _ref$aspectRatio = _ref.aspectRatio,
    aspectRatio = _ref$aspectRatio === void 0 ? 1 : _ref$aspectRatio,
    _ref$resizeDelay = _ref.resizeDelay,
    resizeDelay = _ref$resizeDelay === void 0 ? 100 : _ref$resizeDelay;
  var sourcesAsArray = Array.isArray(src) ? src : [src];
  var validatedSources = sourcesAsArray.filter(isValidImage);
  var fallbackImage = validatedSources[0];
  var imageRef = React.useRef(null);
  var style = {
    objectFit: objectFit,
    aspectRatio: aspectRatio
  };
  var _React$useState = React.useState('PENDING'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    status = _React$useState2[0],
    setStatus = _React$useState2[1];
  var _React$useState3 = React.useState(fallbackImage),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    targetSrc = _React$useState4[0],
    setTargetSrc = _React$useState4[1];
  var resizingDelay = React.useRef(0);
  var resizingDelayTimer = React.useRef();
  React.useEffect(function () {
    // @ts-ignore
    if (global.ssr) return;
    if (!imageRef.current) return;
    var image = imageRef.current;
    // get parent of image element
    var container = image.parentElement;
    if (!container) return;
    var resizeObserver = new ResizeObserver(function (entries) {
      // In order to prevent the 'ResizeObserver loop completed with undelivered notifications.'
      // message, debounce handling the ResizeObserver action by adding a timeout.
      clearTimeout(resizingDelayTimer.current);
      resizingDelayTimer.current = setTimeout(function () {
        var widthAfterResize = entries[0].contentRect.width;
        var newSrcRequired = false;
        if (image.width < widthAfterResize) {
          var newTargetSrc = calculateTargetSrc(image.width, validatedSources, fallbackImage);
          if (targetSrc !== newTargetSrc) {
            setTargetSrc(newTargetSrc);
            newSrcRequired = true;
          }
        } else {
          var _newTargetSrc = calculateTargetSrc(widthAfterResize, validatedSources, fallbackImage);
          if (targetSrc !== _newTargetSrc) {
            setTargetSrc(_newTargetSrc);
            newSrcRequired = true;
          }
        }
        if (status === 'PENDING') {
          setStatus('INITIAL_BREAKPOINT_CALCULATED');

          // We always load the smallest source. If that's also the source we need
          // set INITIAL_LOADED directly.
          // With caching turned on, the onLoad function on the img would only trigger once
          // and thus never unblur the smallest
          if (!newSrcRequired) {
            setStatus('INITIAL_LOADED');
          }
        }

        // On page load, we want 0 delay.
        // After the observer has been triggered once, we set a small debounce.
        if (resizingDelay.current === 0) {
          resizingDelay.current = resizeDelay;
        }
      }, resizingDelay.current);
    });
    resizeObserver.observe(container);

    // eslint-disable-next-line consistent-return
    return function () {
      resizeObserver.unobserve(container);
    };
  }, [fallbackImage, status, targetSrc, validatedSources, resizeDelay]);
  var loadedUrl = useImageLoader(fallbackImage, targetSrc, imageRef);
  function onErrorFallback(e) {
    // Make sure that both URLs are absolute URLs, so we can compare them.
    // Otherwise this error callback will constantly be thrown.
    var link = document.createElement('a');
    link.href = e.target.src;
    var link2 = document.createElement('a');
    link2.href = fallbackImage;
    if (link.href !== link2.href) {
      e.target.src = fallbackImage;
    }
  }
  var classes = c('AdaptivePicture', {
    'AdaptivePicture--initiallyLoaded': status === 'INITIAL_LOADED'
  });
  if (!validatedSources.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("img", {
    style: style,
    className: classes,
    onError: onErrorFallback,
    onLoad: function onLoad(e) {
      if (_onLoad) {
        _onLoad(e);
      }

      // To handle relative URLs
      var current = urlParse.parse(e.target.src);
      var target = urlParse.parse(targetSrc);
      if (status === 'INITIAL_BREAKPOINT_CALCULATED' && current.pathname === target.pathname) {
        setStatus('INITIAL_LOADED');
      }
    },
    src: loadedUrl,
    ref: imageRef,
    alt: alt
  });
};
export default AdaptivePicture;